export default __webpack_public_path__ + "static/media/1.682e561d.mp3";